import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TPersonalDataApplicationDocumentResponse,
  TPersonalDataApplicationsSubmitFormRequest,
} from '~/store/processing-personal/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const postApplicationForm = createAsyncThunk<
  TPersonalDataApplicationDocumentResponse,
  TPersonalDataApplicationsSubmitFormRequest
>('processingPersonal/applicationFormSubmit', async ({ appId, dataForm }, { rejectWithValue }) => {
  try {
    const response = await api.post(
      `/personal-data/public/personal-data/applications/${appId}`,
      dataForm
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const revokePostApplicationForm = createAsyncThunk<
  TPersonalDataApplicationDocumentResponse,
  TPersonalDataApplicationsSubmitFormRequest
>('processingPersonal/applicationFormRevoke', async ({ appId, dataForm }, { rejectWithValue }) => {
  try {
    const response = await api.post(
      `/personal-data/public/personal-data/revoke/applications/${appId}`,
      dataForm
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
